import { store } from '../store'
import { setClientVersion, setServerVersion } from '../store/modules/app'

import { BASE_URL } from './http'
import * as sentry from './sentry'

export async function setupConstants (): Promise<void> {
  try {
    let response = await fetch(`${BASE_URL}/constants`)
    if (!response.ok) {
      throw new Error(`Failed to fetch constants: ${response.status} ${response.statusText}`)
    }
    let constants = await response.json()

    store.dispatch(setClientVersion({
      ref: constants.COMMIT?.trim() ?? undefined,
      date: constants.RELEASE_DATE?.trim() ?? undefined
    }))

    store.dispatch(setServerVersion({
      ref: constants.COMMIT?.trim() ?? undefined,
      date: constants.RELEASE_DATE?.trim() ?? undefined
    }))

    window.constants = constants
  } catch (error) {
    console.error('Failed to setup constants:', error)
    // Set default values if fetch fails
    window.constants = {
      COGNITO: {
        poolId: '',
        frontendClient: {
          id: ''
        }
      }
    }
    throw error
  }
}

export async function setup (): Promise<void> {
  await setupConstants()
  sentry.init()
}
